'use client';

import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { datadogRum } from '@datadog/browser-rum';
import type { ID } from '@segment/analytics-next';
import cookies from 'js-cookie';
import { type PropsWithChildren, useContext, useEffect, useState } from 'react';
import { useAnalytics } from '../../hooks/useAnalytics';
import { SEGMENT_DEPLOYABLE_NAME, SEGMENT_DEPLOYABLE_VERSION } from '../../lib/constants';
import { AnalyticsProvider } from './AnalyticsContext';
import { AnonymousContext } from './anonymousIdContext';
export const SegmentAnalyticsProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <AnalyticsProvider deployableName={SEGMENT_DEPLOYABLE_NAME} deployableVersion={env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || SEGMENT_DEPLOYABLE_VERSION} writeKey={env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}><AnonymousIdProvider>{children}</AnonymousIdProvider></AnalyticsProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const AnonymousIdProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const {
    analytics
  } = useAnalytics();
  const [anonymousId, setAnonymousId] = useState(null);
  let t1;
  if ($[0] !== analytics.segmentInstance) {
    t1 = () => {
      const anonIdFromCookie = cookies.get("ajs_anonymous_id");
      if (!anonIdFromCookie) {
        datadogRum.addAction("No anonymous id found, segment will set one");
      }
      const analyticsWrapperInstance = analytics.segmentInstance;
      analyticsWrapperInstance.ready(() => {
        const segmentInstance = analyticsWrapperInstance.instance;
        if (!segmentInstance) {
          datadogRum.addError(new Error("Segment instance did not load"));
          return;
        }
        const user = segmentInstance.user();
        const anonId = user.anonymousId();
        setAnonymousId(anonId);
        datadogRum.setUserProperty("anonymous_id", anonId);
        datadogRum.addAction("Set segment anonymous id");
      });
    };
    $[0] = analytics.segmentInstance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== anonymousId || $[4] !== children) {
    t3 = <AnonymousContext.Provider value={anonymousId}>{children}</AnonymousContext.Provider>;
    $[3] = anonymousId;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const useAnonymousId = () => {
  const context = useContext(AnonymousContext);
  if (context === undefined) {
    throw new Error("useAnonymousId must be used within a AnonymousIdProvider");
  }
  return context;
};